import { useState } from "react";
import { Row, Col, Drawer, Typography } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";
import { Box } from "@mui/material";

const Header = ({ t, root, loggedIn, user, showGreeting, showProfile }: { t: TFunction; root: string, loggedIn: boolean, user: string, showGreeting: boolean, showProfile: boolean }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const greetings = [
    t("Hello"),
    t("Welcome"),
    t("Greetings"),
    t("Hi"),
    t("Hey"),
    t("Nice to see you"),
    t("Good to see you"),
    t("Howdy"),
  ]

  const randomGreeting = greetings[Math.floor(Math.random() * greetings.length)];

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      // if the root is set and its the root "/" we need to navigate to the root
      if (id !== "Dashboard" && root !== "") {
        navigateTo(root);
        return;
      }
      // scroll to the element with the given id
      const element = document.getElementById(id) as HTMLDivElement;
      if (element) {
        const yOffset = -40;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
      setVisibility(false);
    };
    const navigateTo = (path: string) => {
      window.location.pathname = path.startsWith("/") ? path : `/${path}`;
    }
    const handleLogout = () => {
      // Clear local storage and redirect to the root
      localStorage.clear();
      window.location.reload();
    };

    const helloUserGreetingWithAWave = (user: string) => {
      return `${randomGreeting} ${user} 👋, Please click 'Upload Statement' to get started.`;
    }

    return (
      <>
        {root === "" && (
          <>
            <CustomNavLinkSmall onClick={() => scrollTo("about")}>
              <Span>{t("About")}</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => scrollTo("mission")}>
              <Span>{t("Mission")}</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => scrollTo("server")}>
              <Span>{t("API")}</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => scrollTo("product")}>
              <Span>{t("Dev")}</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => navigateTo("Dashboard")}>
              <Span>{t("Dashboard")}</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall
              style={{ width: "180px" }}
              onClick={() => scrollTo("contact")}
            >
              <Span>
                <Button>{t("Contact")}</Button>
              </Span>
            </CustomNavLinkSmall>
          </>
        )}
        {root !== "" && (
            <Box sx={{ pl: 0, ml: 0, alignItems: "flex-start", justifyContent: "flex-start", display: "flex" }}>
              {loggedIn && showGreeting && (
                <Typography style={{marginTop: "10px", marginRight: "1.3rem", fontSize: "1.0rem" }}>
                  {helloUserGreetingWithAWave(user)}
                </Typography>
              )}
              <CustomNavLinkSmall onClick={() => navigateTo(root)}>
                <Span>{t("Home")}</Span>
              </CustomNavLinkSmall>
              {loggedIn && (
                <>
                  {showProfile && (
                    <CustomNavLinkSmall onClick={() => {navigateTo("Profile")}}>
                      <Span>{t("Profile")}</Span>
                    </CustomNavLinkSmall>
                    )}
                  {!showProfile && (
                    <CustomNavLinkSmall onClick={() => {navigateTo("Dashboard")}}>
                      <Span>{t("Dashboard")}</Span>
                    </CustomNavLinkSmall>
                  )}
                  <CustomNavLinkSmall onClick={() => {handleLogout()}}>
                    <Span>{t("Logout")}</Span>
                  </CustomNavLinkSmall>
                </>
              )}
          </Box>
        )}
      </>
    );
  };

  const getIconHeight = () => {
    if (root === "") {
      return "204px";
    } else {
      return "130px";
    }
  };

  const getIconWidth = () => {
    if (root === "") {
      return "201px";
    } else {
      return "130px";
    }
  };

  const getHeaderStyles = (): React.CSSProperties => {
    if (root === "") {
      return {
        height: "150px",
        padding: "1rem 0.5rem",
      };
    } else {
      return {
        height: "160px",
        padding: "0 0 0 0", // Remove left/right padding
        left: 0,
        position: "relative",
        width: "100vw", // Ensure full viewport width
        marginLeft: 0, // Remove any margin
      };
    }
  };

  return (
    <HeaderSection style={getHeaderStyles()}>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <img src="/img/icons/vandy-io.png" alt="vandyio" width={72} height={72} />
            <SvgIcon src="logo.svg" width={getIconWidth()} height={getIconHeight()} />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
